export default __webpack_public_path__ + "static/media/close.8c73e64b.svg";